export default {
  close: 'Close',
  continue: 'Continue',
  cancel: 'Cancel',
  ok: 'OK',
  save: 'Save',
  saveAndContinue: 'Save and continue',
  skip: 'Skip',
  or: 'Or',
  edit: 'Edit',
  update: 'Update',
  change: 'Change',
  tryAgain: 'Try again',
  required: 'Required',
  finish: 'Finish',
  each: {
    month: 'per month',
    visit: 'per visit',
  },
  subscribe: 'Subscribe',
  goToAccount: 'Go to my account',
  form: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email address',
    dateOfBirth: 'Date of birth',
    birthSex: 'Birth sex',
    male: 'Male',
    female: 'Female',
    other: 'Other',
  },
  errors: {
    generic: {
      title: 'Something went wrong',
      description: 'Please reload the page or try again later.',
    },
  },
  '911':
    'For medical emergencies, call 911 (or your local emergency number) or go to the nearest emergency room',
  auth: {
    signup: {
      title: 'Finish creating your account',
      subtitle: 'Fill in the following details to finish creating your Solv account for {{phone}}',
    },
    phoneForm: {
      title: 'What is your mobile number?',
      redirectTitle: 'To continue, enter your mobile number',
      subtitle:
        'We use your mobile phone number to pull up an existing account or create a new one.',
      fieldTitle: 'Mobile number',
      newToSolv: "Looks like you're new to Solv, welcome!",
      lasteNameField: "Patient's last name",
      cta: 'Send verification code',
      feedbackMode: {
        title: 'Thanks for your feedback!',
        subtitle:
          'Before we can publish your review, you need to sign up or log in with your mobile number.',
      },
    },
    otpForm: {
      title: 'Please verify your mobile number',
      subtitle: 'Enter the 4-digit code sent to your phone',
      subtitleWithPhone: 'Enter the 4-digit code send to {{phone}}',
      enterCode: 'Enter 4-digit Solv code',
      resend: 'Didn’t receive your code?  Get another code <0>by text</0> or <1>by phone call.</1>',
      continueAndAgree: 'Agree and continue',
      verifyAndLogin: 'Verify and log In',
      accountLocked:
        "To protect your privacy, we've locked your account. Please tray again in 2 minutes.",
      otpError: 'Please double check the code and try again.',
      keepMeLoggedIn: 'Keep me logged in',
      persistedLoginWarning:
        'If this is a shared or public device, we do not recommend using this option.',
    },
    clinicDisclaimer:
      '<0>{{clinicName}}</0> uses <1>Solv</1> to make it easy for you to manage your visits and insurance.',
    errors: {
      generic: "Oops. That didn't work. Check the code and try again.",
      accountFrozen:
        'We’ve temporarily locked your account. You must wait {{count}} minute before trying again.',
      accountFrozen_plural:
        'We’ve temporarily locked your account. You must wait {{count}} minutes before trying again.',
      havingTrouble: 'Having trouble? Contact the Solv support team at <0>info@solvhealth.com</0>',
      phoneMismatch:
        'The number you provided does not match what we have on record. To update your number, cancel this visit and re-book with your updated number.',
      phoneMismatchTitle: 'Mismatched mobile phone number',
      cancelYourVisit: 'Cancel your visit',
      tooManyFailedAttempts: 'Too many failed attempts',
    },
  },
  legal: {
    agreeTosAndPp:
      'By clicking <strong>$t(auth.otpForm.continueAndAgree)</strong> I agree to Solv Health’s <0>Terms of Service</0>, and <1>Privacy Policy</1>.',
    agreeCreateAccount:
      'By clicking <strong>$t(auth.otpForm.continueAndAgree)</strong>, I agree to create an account and agree to Solv Health’s <0>Terms of Service</0> and <1>Privacy Policy</1>.',
  },
};
